<h2 mat-dialog-title>{{ config.data.title }}</h2>
<mat-dialog-content class="mat-typography" style="white-space: pre-wrap;">{{ config.data.message }}</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="config.data.optionOne.value" *ngIf="config.data.optionOne">
        {{ config.data.optionOne.display }}
    </button>
</mat-dialog-actions>
